<template>
  <div class="wrapper">
    <div class="left_contain">
      <el-input
        class="margin_top_15 margin_bottom_16"
        placeholder="搜索巡航组名称"
        v-model="searchkey"
      >
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-tree
        ref="cruiseGroupTree"
        :data="treeList"
        node-key="id"
        default-expand-all
        highlight-current
        @node-click="nodeClicked"
        :filter-node-method="filterNode"
      >
        <div class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ data.level == 0 ? data.projectName : data.groupName }}</span>
          <span v-show="data.level !== 0">
            <el-dropdown trigger="click" @command="handleCommand($event, data.id)">
              <el-button icon="el-icon-more" size="mini" @click.stop> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="repeat">重命名</el-dropdown-item>
                <el-dropdown-item command="delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
      </el-tree>
    </div>

    <div class="right_contain" style="border-left: 1px solid rgba(0, 0, 0, 0.09);">
      <div class="right_top_contain" style="border-bottom: 1px solid rgba(0, 0, 0, 0.09);">
        <div class="display_row_start_">
          <div class="display_column_start">
            <span class="font_14_color_000000 margin_bottom">巡航路径名称</span>
            <el-input v-model="cruisingPathName">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-button
            type="primary"
            @click="queryMenthod()"
            style="margin-left:23px;margin-right:9px"
            >查 询</el-button
          >
          <el-button plain @click="resetMenthod()">重 置</el-button>
        </div>
      </div>
      <div class="right_middle_contain">
        <div class="right_middle_row_center">
          <el-button type="text" icon="el-icon-delete" @click="addMenthod">添加</el-button>
          <el-button type="text" icon="el-icon-bottom" @click="deleteMenod">删除</el-button>
        </div>
      </div>
      <div>
        <div class="container" style="padding-top: 0px;">
          <el-table :data="tableData" @selection-change="handleSelectionChange" border>
            <el-table-column type="selection" width="44"></el-table-column>
            <el-table-column
              v-for="(item, index) in tableColumn"
              :key="index"
              :prop="item.prop"
              :formatter="item.formatter"
              :width="item.width"
              :show-overflow-tooltip="true"
              :label="item.label"
            >
              <template slot-scope="scope">
                <div v-if="index == 4 && tableData.length" class="flexSpaceBetween">
                  <el-switch @change="swithcRuisePath(scope.row)" v-model="scope.row.openFlag">
                  </el-switch>
                </div>
                <span v-if="index == 0">{{ scope.row.cruiseGroupName }}</span>
                <span v-if="index == 1">{{ scope.row.name }}</span>
                <span v-if="index == 2">{{ scope.row.cruisePointCount }}</span>
                <span v-if="index == 3">{{ scope.row.templateName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="170px">
              <template slot-scope="scope">
                <div class="display_center_center">
                  <el-button type="text" @click="handleMove(scope.row)">移动</el-button>
                  <el-button type="text" @click="handleSetting(scope.row)">编辑</el-button>
                  <el-button type="text" style="color: #CF1322" @click="handleDelete(scope.row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="text-right mt20"
            background
            layout="prev, pager, next, jumper, total"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <el-dialog
        title="提示"
        v-if="dialogFormVisible"
        :visible.sync="dialogFormVisible"
        width="23%"
      >
        <el-form :model="form">
          <el-form-item label="请选择到移动到的巡航组">
            <el-select style="width: 100%" v-model="form.cruiseGroupId" placeholder="请选择巡航组">
              <el-option
                v-for="(item, index) in list_data"
                :label="item.groupName"
                :value="item.id"
                :key="'editForm-' + index"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="margin_right_10" @click="cancleCruisingGroup">取 消</el-button>
          <el-button type="primary" @click="chooseCruisingGroup">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { PAGE_SIZE, PAGE_SIZES } from '@/lib/constants';
import Axios from '@/lib/axios';
export default {
  name: 'cruisingPlan',
  watch: {
    searchkey(val) {
      this.$refs.cruiseGroupTree.filter(val);
    }
  },
  data() {
    return {
      searchkey: '',
      tableColumn: [
        {
          prop: 'cruiseGroupName',
          label: '巡航组'
        },
        {
          prop: 'name',
          label: '巡航路径'
        },
        {
          prop: 'cruisePointCount',
          label: '预置点'
        },
        {
          prop: 'templateName',
          label: '巡航时间'
        },
        {
          prop: 'openFlag',
          label: '状态'
        }
      ],
      multipleSelection: [],
      pageSize: 10,
      pageSizes: PAGE_SIZES,
      currentPage: 1,
      total: 0,
      treeList: [
        {
          //巡航组列表
          projectName: '巡航组',
          level: 0,
          children: []
        }
      ],
      tableData: [],
      list_data: [],
      cruiseGroupId: '',
      cruiseGroupName: '',
      dialogFormVisible: false,
      cruisingPathId: '',
      cruisingPathName: '',
      form: {
        cruiseGroupId: ''
      }
    };
  },
  mounted() {
    this.queryCruiseGroupList();
  },
  methods: {
    /** 编辑新航路径 */
    handleSetting(row) {
      this.$store.dispatch('updateConfigPlanPush', false);
      this.$router.push({
        path: '/contractorback/configRealStreamCruisingPlan',
        query: {
          cruisingPathData: row,
          isAdd: false
        }
      });
    },

    /** 移动到某个巡航组 */
    handleMove(row) {
      this.dialogFormVisible = true;
      this.cruisingPathId = row.id;
    },

    /** 添加巡航路径 */
    addMenthod() {
      this.$store.dispatch('updateConfigPlanPush', false);
      this.$router.push({
        path: '/contractorback/configRealStreamCruisingPlan',
        query: {
          isAdd: true
        }
      });
    },

    /** 批量删除巡航路径 */
    deleteMenod() {
      this.$confirm('是否删除所选巡航路径?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteChooseRuisePath();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    /** 批量删除巡航路径接口请求 */
    deleteChooseRuisePath() {
      let multipleSelection = JSON.stringify(this.multipleSelection);
      multipleSelection = multipleSelection.replace(/\[|]/g, '');
      Axios.requestWWWForm({
        url: '/unicom/cruisePath/batchDelete',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          ids: multipleSelection
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            this.$message.success('删除成功');
            this.queryCruisePathList();
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 删除巡航路径 */
    handleDelete(row) {
      this.$confirm('是否删除巡航路径?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteRuisePath(row.id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    /** 删除巡航路径接口请求 */
    deleteRuisePath(id) {
      Axios.requestWWWForm({
        url: '/unicom/cruisePath/delete',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          id: id
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            this.$message.success('删除成功');
            this.queryCruisePathList();
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 列表多选 */
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach(element => {
        this.multipleSelection.push(element.id);
      });
    },

    /** 查询 */
    queryMenthod() {
      this.currentPage = 1;
      this.queryCruisePathList();
    },

    /** 重置 */
    resetMenthod() {
      this.cruisingPathName = '';
      this.currentPage = 1;
      this.queryCruisePathList();
    },

    /** 页数筛选 */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryCruisePathList(val);
    },

    /** 巡航路径开启/关闭 */
    swithcRuisePath(row) {
      let openFlag = Number(row.openFlag);
      Axios.requestWWWForm({
        url: '/unicom/cruisePath/switchCruisePath',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          id: row.id,
          openFlag: openFlag
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            if (openFlag == 1) {
              this.$message.success('开启成功');
            } else {
              this.$message.success('停用成功');
            }
          } else {
            if (openFlag == 1) {
              this.$message.error('开启失败');
            } else {
              this.$message.error('停用失败');
            }
            this.tableData.forEach(element => {
              element.openFlag = Boolean(Number(openFlag));
            });
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 查询路径列表 */
    queryCruisePathList(val) {
      Axios.requestWWWForm({
        url: '/unicom/cruisePath/queryList',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          name: this.cruisingPathName || '',
          cruiseGroupId: this.cruiseGroupId,
          pageNo: val || this.currentPage,
          pageSize: 10
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            this.tableData = res.data.result;
            this.total = res.data.totalCount;
            this.tableData.forEach(element => {
              element.openFlag = Boolean(Number(element.openFlag));
              element.cruiseGroupName = this.cruiseGroupName;
            });
          } else {
            this.$message.error('查询巡航路径列表失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 查询巡航组列表 */
    queryCruiseGroupList() {
      Axios.requestWWWForm({
        url: '/unicom/cruisegroup/searchPage',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          groupName: ''
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            let result = res.data.result;
            this.treeList[0].children = result;
            this.list_data = result;

            if (result) {
              let obj = result[0];
              this.cruiseGroupName = obj.groupName; //用于透传在列表中显示（筛选路径名称用）
              this.cruiseGroupId = obj.id;
              this.$nextTick(() => {
                this.$refs['cruiseGroupTree'].setCurrentKey(obj.id);
              });
              this.nodeClicked(obj);
            }
          } else {
            this.$message.error('查询巡航组列表失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 修改巡航组名 */
    updateRuiseGroueName(groupName, id) {
      Axios.requestWWWForm({
        url: '/unicom/cruisegroup/update',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          groupName: groupName,
          id: id
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            this.$message.success('修改成功');
            this.queryCruiseGroupList();
          } else {
            this.$message.error('修改失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 删除巡航组 */
    deleteRuiseGroue(id) {
      Axios.requestWWWForm({
        url: '/unicom/cruisegroup/delete',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          id: id
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            this.$message.success('删除成功');
            this.queryCruiseGroupList();
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 单个巡航组重命名与删除 */
    handleCommand(command, id) {
      if (command === 'repeat') {
        this.$prompt('请输入新的巡航组名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(({ value }) => {
            this.updateRuiseGroueName(value, id);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消输入'
            });
          });
      } else {
        this.$confirm('是否删除该巡航组?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.deleteRuiseGroue(id);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      }
    },

    /** 筛选巡航组 */
    filterNode(value, data) {
      if (!value) return true;
      if (data.groupName) {
        return data.groupName.indexOf(value) !== -1;
      }
      if (data.projectName) {
        return data.projectName.indexOf(value) !== -1;
      }
    },

    /** 取消选择某个巡航组 */
    cancleCruisingGroup() {
      this.dialogFormVisible = false;
      this.cruiseGroupId = '';
    },

    /** 选择某个巡航组 */
    chooseCruisingGroup() {
      this.dialogFormVisible = false;
      Axios.requestWWWForm({
        url: '/unicom/cruisePath/update',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          id: this.cruisingPathId,
          cruiseGroupId: this.form.cruiseGroupId
        }
      })
        .then(res => {
          if (res.data.code == 1000) {
            this.$message.success('移动成功');
            this.form.cruiseGroupId = '';
            this.queryCruisePathList();
          } else {
            this.form.cruiseGroupId = '';
            this.$message.error('移动失败');
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },

    /** 点击树形节点 */
    nodeClicked(data) {
      if (data.level == 0) {
        return;
      }
      this.cruiseGroupId = data.id; //用于通过路径名称筛选
      this.cruiseGroupName = data.groupName; //用于透传显示到列表中
      this.queryCruisePathList(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  background: white;
  border: 1px solid rgba(230, 230, 230, 100);
}

.display_column_start {
  display: flex;
  flex-direction: column;
}

.display_row_spacebetween {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.font_14_color_000000 {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.el-button + .el-button {
  margin-left: 0px;
}

.display_center_center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.buutton_image {
  width: 18px;
  height: 18px;
}

.margin_bottom {
  margin-bottom: 8px;
}

.margin_left {
  margin-left: -15px;
}

.margin_right_41 {
  margin-right: 41px;
}

.margin_right_5 {
  margin-right: 5px;
}

.margin_top_15 {
  margin-top: 15px;
}

.margin_bottom_16 {
  margin-bottom: 16px;
}

.margin_bottom_10 {
  margin-bottom: 10px;
}

.margin_right_10 {
  margin-right: 10px;
}

::v-deep .left_contain {
  width: 340px;
  min-width: 239px;
  // min-height: 100%;
  padding-left: 16px;
  padding-right: 23px;
  overflow: hidden;

  .el-input__icon {
    line-height: 34px;
    width: 25px;
    background: url('~@/assets/img/curisingImg/mb-search.png') center no-repeat;
    background-size: 18px;
  }

  .el-icon-search:before {
    visibility: hidden;
  }

  .el-input__inner {
    border: 1px solid #b3b3b3;
  }

  input::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 0.45);
    font-family: SourceHanSansSC-regular;
  }
  input::-moz-input-placeholder {
    color: rgba(0, 0, 0, 0.45);
    font-family: SourceHanSansSC-regular;
  }
  input::-ms-input-placeholder {
    color: rgba(0, 0, 0, 0.45);
    font-family: SourceHanSansSC-regular;
  }

  .el-tree-node__content {
    height: 32px;
  }

  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #1890ff;
    color: white;
    .el-icon-more {
      color: white;
    }
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 0px;

    .el-button {
      background-color: rgba(220, 38, 38, 0);
      border: 0px solid #dcdfe6;
      padding: 0 0px !important;
    }
  }
}

::v-deep .container {
  .el-table th {
    background-color: rgba(245, 245, 245, 100);
  }

  .el-table thead {
    color: #000;
  }

  .el-table td {
    padding: 6px 0;
  }

  .el-table {
    color: rgba(0, 0, 0, 0.8);
  }

  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 0px solid #ebeef5;
  }

  .el-table--border td,
  .el-table--border th {
    border-right: 0px solid #ebeef5;
  }
}

::v-deep .right_contain {
  flex-grow: 1;
  height: 100%;

  .el-dialog__body {
    padding: 0px 20px;
  }

  .el-dialog__footer {
    padding: 0px 20px 20px;
    text-align: right;
    box-sizing: border-box;
  }
}

::v-deep .right_top_contain {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 17px;
  padding-bottom: 18px;

  .el-input__icon {
    line-height: 34px;
    width: 25px;
    background: url('~@/assets/img/curisingImg/antOutline-profile.png') center no-repeat;
    background-size: 18px;
  }

  .el-icon-search:before {
    visibility: hidden;
  }

  .el-input {
    width: 200px;
  }

  .el-input__inner {
    border: 1px solid #b3b3b3;
  }

  .el-button {
    width: 64px;
  }
}

.display_row_start_ {
  display: flex;
  align-items: flex-end;
  flex-direction: row;
}

.right_middle_contain {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
}

::v-deep .right_middle_row_center {
  display: flex;
  align-items: center;
  flex-direction: row;

  .el-icon-delete {
    background: url('~@/assets/img/curisingImg/mb-trash-can.png') center no-repeat;
    background-size: 15px;
  }

  .el-icon-delete:before {
    content: '替';
    font-size: 14px;
    visibility: hidden;
  }

  .el-icon-bottom {
    background: url('~@/assets/img/curisingImg/md-compare_arrows.png') center no-repeat;
    background-size: 15px;
  }

  .el-icon-bottom:before {
    content: '替';
    font-size: 14px;
    visibility: hidden;
  }

  .el-button--text {
    color: #404040;
  }
}

.query_button {
  width: 64px;
  height: 32px;
  border-radius: 4px;
  background: #1890ff 100%;
  line-height: 32px;
  text-align: center;
  color: #ffffff 100%;
  font-size: 14px;
}

.reset_button {
  width: 64px;
  height: 32px;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  color: #000000 65%;
  font-size: 14px;
  border-color: #000000 25%;
  border-width: 1px;
  border-style: solid;
}

.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.div_flex_row_center {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 32px;
  margin-left: 60px;
}

.dot_view {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #00c76f 100%;
  margin-right: 3px;
}

.font_14_333333_height_32 {
  font-size: 14px;
  color: #333333;
  text-align: center;
}
</style>
